import { StateInterface } from './state.interface'

/**
 * Initial store state
 */
export const state: StateInterface = {
  /*** State of /pull-Api-specific data structures ***/
  alarm: {
    items: {},
    ts: 0,
    new: 0,
    sorting: []
  },
  cluster: {
    consumer: {},
    consumersorting: [],
    settings: {
      test_alpha: false,
      test_beta: false,
      alarm_response: false
    },
    status: [],
    statussorting: [],
    group: {},
    groupsorting: [],
    vehicle: {},
    vehiclesorting: [],
    qualification: {},
    qualificationsorting: []
  },
  dashboard: {
    templates: [],
    selectedTemplate: null
  },
  dm: {
    items: {},
    ts: 0,
    new: 0,
    sorting: []
  },
  events: {
    items: {},
    ts: 0,
    new: 0,
    sorting: []
  },
  localmonitor: {},
  message: {
    items: {},
    ts: 0,
    limit: 0
  },
  message_channel: {
    items: {},
    sorting: [],
    ts: 0
  },
  monitor: {},
  news: {
    items: {},
    ts: 0,
    new: 0,
    sorting: []
  },
  status: {
    group: ''
  },
  statusplan: {},
  ucr: [],
  ucr_active: 0,
  ucr_default: 0,
  user: {
    accesskey: undefined,
    access: {
      messages: false,
      alarm: false,
      event: false,
      news: false,
      report: false,
      status: false,
      status_manual: false,
      status_planer: false,
      status_vehicle: false,
      localmonitor: false,
      monitor: false,
      management: false,
      message_channel: false,
      message_channel_actions: {
        attach: false,
        comment: false,
        edit: false,
        edit_all: false
      },
      news_fields: {
        address: 0,
        author: 0,
        files: 0,
        read: 0,
        recipients: 0,
        vehicles: 0,
        report: 0,
        text: 0,
        title: 0,
        response_count: 0,
        response_names: 0,
        message_channel: 0
      },
      dashboard: true,
      dashboard_widgets: {
        alarm_informations: false,
        countdown: false,
        direct_messages: false,
        iframe: false,
        map: false,
        messages: false,
        messenger: false,
        status_compact: false,
        status_detail: false,
        vehicle_status: false,
        vehicle_status_history: false
      }
    }
  },
  /*** State of deriving data structures ***/
  messenger: {
    channels: {},
    layout: {
      selectedChannelId: null,
      selectedLayoutIndex: null,
      channelCollection: {
        '0': [],
        '1': [],
        '2': [],
        '3': []
      }
    }
  },
  vehicle_status_history: {
    history: {},
    ts: 0,
    isInitialised: false
  },
  custom_monitor: {
    sortedQualifications: []
  },
  /*** Application-specific state ***/
  app: {
    initialized: false,
    darkMode: false
  },
  encryption_keys: {
    items: {},
    sorting: [],
    ts: 0,
    user_id: 0
  },
  jwt: undefined,
  navigation: {
    customTemplate: '',
    auxNavTemplate: ''
  },
  pull_service: {
    ts: 0
  }
}
